module.exports = __webpack_public_path__ + "static/media/icon_kijkwijzer_9.ef0b80d8.svg";